
// src/helpers/message-storage.js

export default {
    setItem: (key, value) => localStorage.setItem(key, value),
    getItem: (key) => new Promise((resolve, reject) => {
        resolve(localStorage.getItem(key))
    })
}


// WEBPACK FOOTER //
// ./src/helpers/message-storage.js